import React from 'react';
import PropTypes from 'prop-types';
import { entityShape, pluginShape, relationshipShape } from './helpers/propTypes';

const EntityBlockByType = ({
  data,
  typeToPlugin,
  onRemoveClick,
  className,
  container,
  onReferenceClick
}) => {
  const { entity } = data;
  const { entityType } = entity;
  const plugin = typeToPlugin[entityType];
  const { EntityBlock } = plugin;
  return (
    <EntityBlock
      onReferenceClick={
        onReferenceClick ? () => onReferenceClick({ entityType, entity }) : undefined
      }
      className={className}
      entity={entity}
      onRemoveClick={onRemoveClick}
      container={container}
    />
  );
};

EntityBlockByType.propTypes = {
  /**
   * A classname for this component
   */
  className: PropTypes.string,
  /**
   * The relationship & entity we want to show.
   */
  data: PropTypes.shape({
    entity: entityShape,
    relationship: relationshipShape
  }).isRequired,
  /**
   * A map of entity type to plugin.
   */
  typeToPlugin: PropTypes.objectOf(pluginShape),
  /**
   * Handler when clicking remove entity button.
   */
  onRemoveClick: PropTypes.func.isRequired,
  /**
   * A container to attach tooltips to.
   */
  container: PropTypes.object,
  /**
   * Callback fired when a user clicks on a reference
   * Handler of shape: ({ entityType, entity }) => *
   */
  onReferenceClick: PropTypes.func
};

export default EntityBlockByType;
